import {VerifyCodeFormEnum, VerifyCodeFormType} from '../../../service/user/user-verify-code';

export const initialValues: VerifyCodeFormType = {
    [VerifyCodeFormEnum.Code]: '',
};
